// istanbul ignore file
import React, { useState } from 'react'
import ViewKpiInformation from './ViewKpiInformation'
import Modal from '../../../components/Modal'
import Typography from '@mui/material/Typography'
import LanguageStrings from '../../../i18n/locales'
import { deleteCustomKpiByKpiDefinitionId } from '../services/DeleteCustomKpiService'
import { useNavigate } from 'react-router-dom'
import { CircularProgress } from '@mui/material'
import { type OperationPermissionState } from '../../dashboard/redux/operationPermissionSlice'
import { useSelector, connect, type ConnectedProps } from 'react-redux'
import { type RootState } from '../../../store'
import { useAuth } from 'react-oidc-context'
import { getOperationPermissions } from '../../dashboard/redux/actionCreator'

const kpiDetails = LanguageStrings().ThermalIQStrings.KpiDetailsComponent

const commonStyle = {
  fontFamily: 'Honeywell Sans Web',
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.5px',
  textAlign: 'center',
  cursor: 'pointer',
  color: '#64C3FF'
}

interface ActionComponentProps {
  row: any
  fetchAllkpiList: () => void
  isKpiSelected: boolean
  isAssetLevel: boolean
  setIsKpiSelected: () => void
}

const ActionComponent = (props: Props): JSX.Element => {
  const [showViewModal, setShowViewModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showDeleteSuccessModal, setShowDeleteSuccessModal] = useState(false)
  const [showDeleteFailureModal, setShowDeleteFailureModal] = useState(false)
  const [deleteErrorMessage, setDeleteErrorMessage] = useState(null)
  const [isLoader, setIsLoader] = useState(false)
  const navigate = useNavigate()
  const operationPermissions: OperationPermissionState = useSelector((state: RootState) => state.operationPermissions)
  const auth = useAuth()

  React.useEffect(() => {
    (!operationPermissions.updated && props.getOperationPermissions(auth.user?.profile.sub as string))
  }, [])

  const handleEditClick = (): void => {
    navigate('/edit-custom-kpi', { state: { kpiDefinitionId: props.row.kpiDefinitionId } })
  }
  const handleViewClick = (): void => {
    setShowViewModal(true)
  }
  const closeViewModal = (): void => {
    props.setIsKpiSelected()
    setShowViewModal(false)
  }

  const handleDeleteClick = (): void => {
    setShowDeleteModal(true)
  }
  const handleDelete = (): void => {
    setShowDeleteSuccessModal(false)
    setShowDeleteModal(false)
    props.fetchAllkpiList()
  }
  const closeDeleteModal = (): void => {
    setShowDeleteModal(false)
  }

  const handleDeleteConfirm = (): void => {
    setIsLoader(true)
    void deleteCustomKpiByKpiDefinitionId(props.row.kpiDefinitionId,
      (httpStatus) => {
        setIsLoader(false)
        setShowDeleteModal(false)
        setShowDeleteSuccessModal(true)
      },
      (errorMessage, httpStatus) => {
        setIsLoader(false)
        setDeleteErrorMessage(errorMessage)
        setShowDeleteFailureModal(true)
      }
    )
  }

  const handleDeleteWithFailure = (): JSX.Element => {
    return (
      <Modal title={'Loading...'}>
        <div className="CircularprogressAmi">
          <CircularProgress />
        </div>
      </Modal>
    )
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', height: '39px', padding: '0px 40px 0px 0px', alignItems: 'center', gap: '40px' }}>
        {
          operationPermissions.permissions.can_read_tiq_Kpis
            ? <Typography sx={commonStyle} onClick={handleViewClick}>{kpiDetails.View}</Typography>
            : <></>
        }
        {
          operationPermissions.permissions.can_modify_tiq_kpis
            ? <Typography sx={commonStyle} onClick={handleEditClick}>
                {kpiDetails.Edit}
              </Typography>
            : <></>
        }
        {
          operationPermissions.permissions.can_delete_tiq_kpis
            ? <Typography sx={commonStyle} onClick={handleDeleteClick}>{kpiDetails.Delete}</Typography>
            : <></>
        }
      </div>
      {(showViewModal || props.isKpiSelected)
        ? <ViewKpiInformation
            assetId={props.row.assetId} assetTypeId={props.row.assetTypeId} kpiDefinitionId={props.row.kpiDefinitionId}
            onClose={closeViewModal} isAssetLevel={props.isAssetLevel}
          />
        : null
      }
      {showDeleteModal
        ? <Modal
            title={`Delete Custom KPI ${typeof (props.row as { kpiName: string })?.kpiName === 'string' && (props.row as { kpiName: string }).kpiName.length > 15 ? `${(props.row as { kpiName: string }).kpiName.slice(0, 15)}...` : typeof (props.row as { kpiName: string })?.kpiName === 'string' ? (props.row as { kpiName: string }).kpiName : ''}`}
            onClose={closeDeleteModal}
            width={'600px'}
            height={'292px'}
            buttonTypeNegative='hollow'
            LabelNegative='Cancel'
            LabelPositive='Delete'
            onClickPositive={handleDeleteConfirm}
            onClickNegative={closeDeleteModal}
        >
          <div style={{ margin: '20px 0 10px 0' }}>
            <Typography sx={{ fontFamily: 'Honeywell Sans Web', fontSize: '16px', lineHeight: '24px' }}>
              {kpiDetails.DeleteKpiConfirmation}
              <br/><br/>
              {kpiDetails.DeleteConfirmationWarning}
            </Typography>
          </div>
        </Modal>
        : null
      }
      { isLoader && handleDeleteWithFailure()}
      {showDeleteSuccessModal
        ? <Modal
          title={'Successfully Deleted'}
          onClose={handleDelete}
          width={'399px'}
          height={'272px'}
          LabelPositive='Okay'
          onClickPositive={handleDelete}
        >
          <div style={{ margin: '20px 0 50px 0' }}>
            <Typography sx={{ fontFamily: 'Honeywell Sans Web', fontSize: '16px', lineHeight: '24px' }}>{kpiDetails.DeleteSuccessMessage}</Typography>
          </div>
        </Modal>
        : null
      }
      {showDeleteFailureModal
        ? <Modal
          title={`Delete Custom KPI ${props.row.kpiName as string}`}
          onClose={handleDelete}
          width={'399px'}
          height={'272px'}
          LabelPositive='Okay'
          onClickPositive={handleDelete}
        >
          <div style={{ margin: '20px 0 50px 0' }}>
            <Typography sx={{ fontFamily: 'Honeywell Sans Web', fontSize: '16px', lineHeight: '24px' }}>{deleteErrorMessage}</Typography>
          </div>
        </Modal>
        : null
      }
    </>
  )
}

interface DispatchToProps {
  getOperationPermissions: (sub: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub))
})

const connector = connect(null, mapDispatchToProps)

type ReduxProps = ConnectedProps<typeof connector>
type Props = ActionComponentProps & ReduxProps

export default connector(ActionComponent)
